export const FIRST_ELEMENT = 0;

export const ONE = 1;

export const ID_CALL_SPECIALIST = 102905;

export const COLOR_CHECKBOX_ACTIVE = '#d72e43';

export const RED_COLOR_TAB_ACTIVE = '#dd4333';

export const URL_BANNER_STEPS = '/static/images/center/';

export const COUNT_STEPS = 5;

export const COUNT_SLOTS = 8;
